import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Button, message } from "antd";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import styles from "./index.module.less";
import cvUploading from "@/assets/attachementResume/cvUpload.png";
import classNames from "classnames";
import Previewer from "@/components/Resume/Upload/previewer";
import { useLocale } from "@/hooks/useLocale";
import CModal from "@/components/Modal";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const MAX_FILE_SIZE_MB = 20;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const ResumeUpload = ({ isOpen, onClose, refreshData, submitCallback, locale, type, }) => {
    const { t } = useLocale("attachmentResume", locale);
    const fileRef = React.useRef(null);
    const [files, setFiles] = useState([]);
    const validTypes = [
        "image/jpeg",
        "image/png",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    const onFileChange = async (e) => {
        const selectedFiles = Array.from(e.target.files || []);
        // 重置input的值以允许重复选择同一文件
        if (fileRef.current)
            fileRef.current.value = "";
        // 文件大小验证
        const oversizedFiles = selectedFiles.filter((file) => file.size > MAX_FILE_SIZE_BYTES);
        if (oversizedFiles.length > 0) {
            message.error({
                content: t("attachmentNotOver20"),
                key: "fileSizeError_" + Date.now(),
            });
            return;
        }
        // 文件类型验证
        const invalidFiles = selectedFiles.filter((file) => !validTypes.includes(file.type));
        if (invalidFiles.length > 0) {
            message.error(t("notSupportType"));
            return;
        }
        // 分类验证
        const images = selectedFiles.filter((f) => f.type.includes("image"));
        const docs = selectedFiles.filter((f) => f.type.includes("pdf") ||
            f.type.includes("msword") ||
            f.type.includes("wordprocessingml"));
        if (docs.length > 1) {
            message.error(t("onlyOneTypeSupport"));
            return;
        }
        if (images.length > 2) {
            message.error(t("imageLimit2"));
            return;
        }
        if (docs.length > 0 && images.length > 0) {
            message.error(t("notSupportMixType"));
            return;
        }
        // 生成预览信息
        const filesWithPreview = await Promise.all(selectedFiles.map(async (file) => {
            const preview = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.readAsDataURL(file);
            });
            let type = "image";
            if (file.type.includes("pdf"))
                type = "pdf";
            if (file.type.includes("msword"))
                type = "doc";
            if (file.type.includes("wordprocessingml"))
                type = "docx";
            return { file, preview, type };
        }));
        setFiles(filesWithPreview);
    };
    //清除数据
    const clearData = () => {
        setFiles([]);
    };
    return (_jsx(CModal, { open: isOpen, onCancel: onClose, title: _jsx("span", { style: { fontWeight: "700" }, children: t("uploadAttachmentResume") }), centered: true, footer: null, width: files?.length === 0 ? 780 : 1000, className: "cv-uploader-modal", children: _jsx("div", { className: classNames(styles.cvUploaderWrapper), children: files?.length === 0 ? (_jsxs("div", { className: classNames(styles.cvUploaderWrapperUpload), children: [_jsx("img", { src: cvUploading, alt: "", style: { width: "80px" } }), _jsx("div", { className: classNames(styles.cvUploaderWrapperUploadTip), children: t("uploadCvTip") }), _jsx("input", { ref: fileRef, type: "file", multiple: true, style: { display: "none" }, onChange: onFileChange, accept: ".jpg,.jpeg,.png,.pdf,.doc,.docx" }), _jsx(Button, { type: "primary", style: {
                            marginTop: "32px",
                            height: "40px",
                            borderRadius: "10px",
                            background: "#577CF6",
                            fontWeight: "bold",
                            boxShadow: "unset !important",
                        }, onClick: () => fileRef.current?.click(), children: t("uploadAttachmentResume") })] })) : (_jsx(Previewer, { uploadFiles: files, clearFiles: () => {
                    setFiles([]);
                }, showDownload: false, isUpload: true, isLink: false, reloadData: () => {
                    refreshData?.();
                    if (type == 2) {
                        onClose?.();
                    }
                }, submitCallback: submitCallback, locale: locale })) }) }));
};
export default ResumeUpload;
